export const parseHTMLText = (input, langForInUrl) => {
    if(!input) return null;

    if(input.includes("tmsqr.com/")) {
        return input.replaceAll("tmsqr.com/", `tmsqr.com${langForInUrl}/`)
    }

    return input;
};